import {AbstractControl, ValidatorFn} from '@angular/forms';

import {RequiredValidatorKey} from './core-validator-keys';
import {PhoneValidatorKey} from './custom-validator-keys';

export function PhoneValidator(codes: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value as {
            phone: string;
            code: string;
        };

        if (
            !controlValue ||
            !controlValue.phone ||
            !controlValue.code ||
            (controlValue.phone && controlValue.phone.trim() === '')
        ) {
            return {[RequiredValidatorKey]: true};
        }

        if (codes.indexOf(controlValue.code) < 0) {
            return {[PhoneValidatorKey]: true};
        }

        /**
         * Minimum phone size is 4 digits(size without phone code)  - Saint Halena(+290) and Niue(+683)
         * Maximum phone size is 13 digits -  Austria (+43)
         */
        if (!controlValue.phone.match(/^[0-9]{4,13}$/g)) {
            return {[PhoneValidatorKey]: true};
        }

        return null;
    };
}
